import React from 'react';
import type { RegisteredMember } from '../../types/member';
import { 
    GENDER_MAP, 
    POSITION_MAP, 
    MINISTRY_TEAM_MAP, 
    CELL_GROUP_MAP, 
    BAPTISM_MAP, 
    MEMBER_CLASS_MAP 
} from '../../utils/mappings';
import { 
    UserIcon, 
    CakeIcon, 
    PhoneIcon, 
    EnvelopeIcon, 
    CalendarDaysIcon,
    SparklesIcon,
    UserGroupIcon,
    MapPinIcon,
    BookOpenIcon,
    BuildingStorefrontIcon,
    TagIcon
} from '@heroicons/react/24/outline';

interface PersonalInfoProps {
  member: RegisteredMember;
}

const InfoItem: React.FC<{ icon: React.ElementType, label: string; value: React.ReactNode }> = ({ icon: Icon, label, value }) => (
    <div className="flex items-center justify-between py-3 text-sm">
        <dt className="flex items-center text-gray-500">
            <Icon className="h-5 w-5 mr-2 text-gray-400" />
            {label}
        </dt>
        <dd className="text-gray-900 font-medium">{value || '-'}</dd>
    </div>
);

const PersonalInfo: React.FC<PersonalInfoProps> = ({ member }) => {
  return (
    <div className="bg-white p-6 rounded-xl shadow-lg print:shadow-none print:border print:border-gray-200">
      <div className="grid grid-cols-1 md:grid-cols-2 print:grid-cols-2 gap-x-12 gap-y-8">
        {/* 개인신상 정보 섹션 */}
        <div>
          <h3 className="text-xl font-bold text-gray-800 border-b pb-2 mb-4">개인신상 정보</h3>
          <dl className="divide-y divide-gray-200">
            <InfoItem icon={UserIcon} label="이름" value={member.name} />
            <InfoItem icon={SparklesIcon} label="성별" value={GENDER_MAP[member.gender]} />
            <InfoItem icon={CakeIcon} label="생년월일" value={member.dateOfBirth} />
            <InfoItem icon={PhoneIcon} label="연락처" value={member.phoneNumber} />
            <InfoItem icon={EnvelopeIcon} label="이메일" value={member.email} />
            <InfoItem icon={CalendarDaysIcon} label="등록일" value={member.registrationDate} />
          </dl>
        </div>

        {/* 교회 정보 섹션 */}
        <div>
          <h3 className="text-xl font-bold text-gray-800 border-b pb-2 mb-4">교회 정보</h3>
          <dl className="divide-y divide-gray-200">
            <InfoItem icon={TagIcon} label="직분" value={POSITION_MAP[member.position]} />
            <InfoItem icon={UserGroupIcon} label="사역팀" value={member.ministryTeam ? MINISTRY_TEAM_MAP[member.ministryTeam] : '-'} />
            <InfoItem icon={MapPinIcon} label="소속구역" value={member.cellGroup ? CELL_GROUP_MAP[member.cellGroup] : '-'} />
            <InfoItem icon={BookOpenIcon} label="세례" value={BAPTISM_MAP[member.baptism]} />
            <InfoItem icon={BuildingStorefrontIcon} label="이전출석교회" value={member.previousChurch} />
            <InfoItem icon={TagIcon} label="성도구분" value={MEMBER_CLASS_MAP[member.memberClass]} />
          </dl>
        </div>
      </div>
    </div>
  );
};

export default PersonalInfo;
